<template>
  <div class="app-container">
    <!-- 采购员 -->
    <BjInput
      v-model="queryParams.categoryName"
      style="width: 25%"
      :maxlength="MAX_LENGTH.DEFAULT"
      :placeholder="$t('billingPage.searchName')"
      clearable
      @keyup.enter.native="handleQuery"
    />
    <div style="float: right">
      <el-button type="primary" plain @click="handleQuery">{{ $t('searchText') }}</el-button>
      <el-button type="default" plain @click="resetQuery">{{ $t('resetText') }}</el-button>
    </div>

    <div v-for="(item,index) in tableData" :key="index" style="margin-top:30px">
      <div v-if="item && item.group">
        <BjDivider right-fixed>{{ item.group }}
          <template #right> </template>
        </BjDivider>
        <el-table :data="tableData[index].items" style="width: 100%" border>
          <el-table-column prop="billCategoryName" :label="$t('billingPage.serviceType')" width="180" align="center"> </el-table-column>
          <el-table-column prop="price" :label="$t('billingPage.price')" width="180" align="center"> </el-table-column>
          <el-table-column prop="description" :label="$t('billingPage.description')" align="center"> </el-table-column>
        </el-table>
      </div>
    </div>

  </div>
</template>

<script>
import { billApi } from '@/api';
export default {
  data() {
    return {
      queryParams: {
        categoryName: null,
      },
      tableData: [],
    };
  },
  created() {
    this.handleQuery();
  },
  methods: {
    // 搜索按钮
    handleQuery() {
      this.getPageList(this.queryParams);
    },
    // 重置按钮
    resetQuery() {
      this.queryParams.categoryName = null;
      this.handleQuery();
    },
    // 获取数据列表
    getPageList(p) {
      billApi.getBillPriceCardList(p).then(e => {
        this.tableData = e.data;
      })
      .catch(e => {
        console.log(e);
        this.tableData = [{group: 'NO DATA', items: []}, {group: 'NO DATA', items: []}];
      });
    },
  },
};
</script>
